const formTemplateStatus = {
    DRAFT : 0,

    IN_PRODUCTION : 1,

    PUBLISHED : 2

};

angular.module('gw-um-j2js')
    .constant('formTemplateStatus', formTemplateStatus);